import React, { type HTMLAttributes } from 'react';
import classNames from 'classnames';
import { NeedHelpModal } from '$quantum/organisms/NeedHelpModal';
import { TopNavigationBar } from '$quantum/organisms/TopNavigationBar';
import { CurrentUserContainer } from '$layout/partials/Header/components/CurrentUser';

import styles from './index.module.scss';

export type CustomerTopNavigationBarProps = HTMLAttributes<HTMLDivElement>;

/**
 * Templates have to be Server Components.
 * Might conditionally load components based on page context.
 */
export function CustomerTopNavigationBar({
  className,
  ...props
}: CustomerTopNavigationBarProps): JSX.Element {
  return (
    <div className={classNames(CustomerTopNavigationBar.displayName, styles.component, className)} {...props}>
      <TopNavigationBar
        className={classNames(styles.sticky, styles.TopNavigationBar)}
        showLoginLink={false}
        navigationMenuFooter={<CurrentUserContainer className={classNames(styles['current-user_mobile'])} />}
      >
        <span className={styles['delimiter-right']} />

        <div className={classNames(styles['header-right'])}>
          <NeedHelpModal className={classNames('need-help-light', styles['need-help-cta'])} />
          <CurrentUserContainer className={classNames(styles['current-user_desktop'])} />
        </div>
      </TopNavigationBar>
    </div>
  );
}
CustomerTopNavigationBar.displayName = 'CustomerTopNavigationBar';
